import Autolinker from "@neard-packages/autolinker";

export function getLinksFromText(text: string) {
  return Autolinker.parse(text, { urls: true, email: false, phone: false });
}
